import React from 'react';
import { keyframes, styled } from '@components-shared/src/stitches';
import { TabContent } from '@components/main-components/tabs/Tab';

export const StyledTabContent = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: string;
}) => {
  return (
    <TabContent value={value} className="mt-3 flex w-full flex-col lt:max-w-sm">
      {children}
    </TabContent>
  );
};

export const LoadingEllipsis = () => {
  return (
    <LoadingWrapper>
      <span />
      <span />
      <span />
    </LoadingWrapper>
  );
};

const flashing = keyframes({
  '0%': {
    opacity: 0.2,
  },
  '20%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0.2,
  },
});

const LoadingWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  span: {
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    animation: `${flashing} 1.4s infinite linear`,
    margin: '0 4px',
    display: 'inline-block',

    '&:nth-child(2)': {
      'animation-delay': '.2s',
    },

    '&:nth-child(3)': {
      'animation-delay': '.4s',
    },
    backgroundColor: '$neutral800',
  },
});
